__turbopack_context__.v({
  "buttonItemContainer": "dropdownPanelButtons-module-scss-module__Z1TNhG__buttonItemContainer",
  "contentPanel": "dropdownPanelButtons-module-scss-module__Z1TNhG__contentPanel",
  "navContainer": "dropdownPanelButtons-module-scss-module__Z1TNhG__navContainer",
  "viewport": "dropdownPanelButtons-module-scss-module__Z1TNhG__viewport",
  "viewportContent": "dropdownPanelButtons-module-scss-module__Z1TNhG__viewportContent",
});
